module.exports = __webpack_public_path__ + "static/media/i_lt.d45c18f5.pdf";